import styled from 'styled-components';
import { detectReferencePoint } from '../../../functions/launcherElementFunctions/detectReferencePoint';
import { updateObjectNestedProperties } from '../../../functions/objectFunctions/updateObjectNestedProperties';
import { useElements, useScene } from '../../../hooks';
import { LauncherElement } from '../../../types/launcherElement';
import { NumberInput } from '../inputs/NumberInput';

export const PositionInputGroup = () => {
  const scene = useScene();
  const lastSelectedElementID = scene.selectedElementIDs.slice(-1)[0];
  const [selectedElement, setSelectedElement] = useElements<LauncherElement>({
    id: lastSelectedElementID,
  });
  const point = detectReferencePoint(selectedElement);

  let xPropName = 'left';
  let yPropName = 'top';
  switch (point) {
    case 'topLeft':
      xPropName = 'left';
      yPropName = 'top';
      break;
    case 'topRight':
      xPropName = 'right';
      yPropName = 'top';
      break;
    case 'bottomLeft':
      xPropName = 'left';
      yPropName = 'bottom';
      break;
    case 'bottomRight':
      xPropName = 'right';
      yPropName = 'bottom';
      break;
  }

  const elementPos = {
    x: selectedElement?.props?.class?.[xPropName],
    y: selectedElement?.props?.class?.[yPropName],
  };

  const updateStyleProp = (propName: string, value: any) => {
    setSelectedElement((prev) =>
      updateObjectNestedProperties(prev, {
        [`props.class.${propName}`]: value,
      })
    );
  };

  return (
    <>
      <Container>
        <NumberInput
          id={`${lastSelectedElementID}-x-input`}
          label="x"
          value={elementPos.x}
          precision={2}
          placeholder="auto"
          onChange={(newNumberValue) =>
            updateStyleProp(xPropName, newNumberValue)
          }
          disabled={point === 'relative'}
          centered
        />
        <NumberInput
          id={`${lastSelectedElementID}-y-input`}
          label="y"
          value={elementPos.y}
          precision={2}
          placeholder="auto"
          onChange={(newNumberValue) =>
            updateStyleProp(yPropName, newNumberValue)
          }
          disabled={point === 'relative'}
          centered
        />
      </Container>
    </>
  );
};

const Container = styled.div`
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 5px;
`;
